<!--
 * @Author: guoyu
 * @Date: 2020-05-08 14:33:26
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-10-09 19:43:23
 * @Description: 下单页面(新人体验区进入默认使用新人红包)
 -->
<template>
  <div class="order-submit-page">
    <header class="order-head">確認訂單</header>
    <div class="pc-container-left">
      <!-- skill描述 -->
      <order-info
        :class="{ 'white-block': !isPc }"
        v-model="skillInfo"
        v-bind="goodsInfo"
      ></order-info>
      <!-- 计费模式 -->
      <UnitPrice
        v-model="unitMode"
        ref="refUnit"
        :skillInfo="skillInfo"
        :isFromNew="isFromNew"
      >
      </UnitPrice>
      <!-- 支付选项 -->
      <pay-type
        v-if="!isIos"
        v-model="paymentMethod"
        :isFromNew="isFromNew"
        :userBalance="accountInfo.balance"
        :price="payPrice"
        :isPc="isPc"
        ref="payTypeRef"
        @changeItem="getPayMethodInfo"
      ></pay-type>
      <credit-card
        v-show="creditVisible"
        @handleRadio="handleRadio"
        :class="{ 'white-block': !isPc }"
      ></credit-card>
      <!-- 滿贈優惠 -->
      <GiftWithPurchase
        :class="{ 'white-block': !isPc }"
        v-if="
          !isFromNew && skillInfo.giveAwayList && skillInfo.giveAwayList.length
        "
        v-model="skillInfo.count"
        :countCouponsList="skillInfo.giveAwayList"
      >
      </GiftWithPurchase>
      <!-- 優惠券相关 -->
      <coupons-info
        :class="{ 'white-block': !isPc }"
        :isFromNew="isFromNew"
        :allPrice="allPrice"
        :firstCoupon="firstCoupon"
        :couponsList="realCouponList"
        :couponUuid="couponUuid"
        :isPc="isPc"
        :paymentMethod="paymentMethod"
        ref="couponsRef"
        @change="getCoupons"
      ></coupons-info>
      <div class="email-info" v-if="isLanxin">
        <p class="email-title">電子信箱</p>
        <div>
          <el-input
            v-model="email"
            class="email-input"
            placeholder="請填寫付款人電子郵箱"
            :class="{ 'eamil-Error': emailError }"
            @input="emailError = false"
            @blur="verifyEmail"
          ></el-input>
          <div class="tip-wrap">
            填寫付款人電子信箱，用以收取支付通知信與電子發票。
          </div>
        </div>
      </div>
    </div>
    <div class="pc-container-right">
      <!-- <div class="rebate-tip">
        下單筆筆<span class="rebate-per">返現10%</span>防疫金
      </div> -->
      <!-- 支付金额 -->
      <pay-info
        :isIos="isIos"
        :price="payPrice"
        :allPrice="allPrice"
        :coupons="coupons"
        :isFromNew="isFromNew"
        :isPc="isPc"
        :couponInfo="currentCoupon"
        :skillInfo="skillInfo"
        :sendCount="sendCount"
        :count="skillInfo.count"
        :unitMode="unitMode"
      ></pay-info>
      <!-- 订单提交 -->
      <submit-button
        class="submit-order"
        ref="submitButton"
        v-if="submitAllow"
        v-bind="sumitInfo"
        :tokenTerm="tokenTerm"
        @bindPhoneComplete="init"
      ></submit-button>
    </div>
  </div>
</template>
<script>
import OrderInfo from './components/order-info';
import CouponsInfo from './components/coupons-info';
import UnitPrice from './components/price-unit';
import PayInfo from './components/pay-info';
import PayType from './components/pay-type';
import SubmitButton from './components/submit-button';
import GiftWithPurchase from './components/gift-with-purchase';
import creditCard from '@/components/PayFast/credit-card';

export default {
  components: {
    OrderInfo,
    CouponsInfo,
    PayInfo,
    PayType,
    SubmitButton,
    GiftWithPurchase,
    UnitPrice,
    creditCard
  },
  data() {
    return {
      tokenTerm: '',
      creditVisible: false,
      isIos: false,
      paymentMethod: 'Balance', // 支付渠道,新人体验区进入不选中支付方式

      skillInfo: {}, // 陪玩信息
      coupons: 0, // 优惠金额
      couponUuid: this.$route.query.couponUuid, // 優惠券id
      accountInfo: {}, // 用户账户信息
      isFromNew: false, // 是否从新人体验区进入
      orderNo: this.$route.query.orderNo, // 未支付的订单id
      submitAllow: false,
      couponsList: [],
      isPc: true,
      quickMatchInfo: {}, // 用于判断极速下单禁止加数量
      currentCoupon: {},
      unitMode: {}, // 计费方式
      email: window.localStorage.getItem('OrderEmail') || '',
      emailError: false
    };
  },
  computed: {
    payPrice() {
      const price = this.$route.query.quickMatchUuid
        ? this.skillInfo.count * this.units - (this.coupons || 0)
        : this.skillInfo.count * this.units -
          (this.coupons || 0) -
          this.firstCoupon;
      return price >= 0 ? price : 0;
    },
    units() {
      // 如果是极速约单，使用极速约单价格
      if (this.$route.query.quickMatchUuid) {
        return this.quickOrderUnit;
      }
      return this.isFromNew &&
        this.skillInfo.selfSpreadPrice &&
        this.skillInfo.redBagFreeFlag &&
        !this.unitMode.id
        ? this.skillInfo.selfSpreadPrice
        : this.unitMode.price;
    },
    // 极速约单单价
    quickOrderUnit() {
      return this.isFromNew
        ? this.quickMatchInfo.salesPrice
        : this.quickMatchInfo.originPrice;
    },
    firstCoupon() {
      if (this.skillInfo.firstOrderPrivilege) {
        return this.$route.query.quickMatchUuid
          ? 0
          : this.skillInfo.firstOrderDiscount || 0;
      }
      return 0;
    },
    allPrice() {
      if (this.isQuickOrder) {
        return this.quickOrderUnit * this.quickMatchInfo.count;
      }
      return this.skillInfo.count * this.unitMode.price || 0;
    },
    sendCount() {
      if (this.isFromNew) return 0;
      return this.getMaxSend(this.skillInfo.count, this.skillInfo.giveAwayList);
    },
    /**
     * @description: 陪陪uuid,判断专属優惠券是否可用
     */
    playerUuid() {
      return this.skillInfo.userUuid;
    },
    userInfo() {
      return this.$store.state.app.userInfo || {};
    },
    sumitInfo() {
      return {
        count: this.skillInfo.count, // 小时数
        skillInfo: this.skillInfo,
        accountInfo: this.accountInfo, // 用户账户信息
        payType: this.paymentMethod,
        couponUuid: this.couponUuid, // 優惠券id
        payPrice: this.payPrice,
        payMethodInfo: this.payMethodInfo,
        noPayOrderInfo: this.orderInfo, // 未支付的订单信息
        isFromNew: this.isFromNew,
        skillPrice: this.unitMode,
        email: this.email
      };
    },
    goodsInfo() {
      let { price: salesPrice, salesUnit } = this.unitMode;
      if (this.isQuickOrder) {
        salesPrice = this.quickOrderUnit;
      }
      return {
        salesPrice: salesPrice || this.skillInfo.salesPrice,
        salesUnit: salesUnit || this.skillInfo.salesUnit,
        isFromNew: this.isFromNew,
        quickMatchCount: this.quickMatchInfo.count
      };
    },
    isQuickOrder() {
      return !!this.$route.query.quickMatchUuid;
    },
    /**
     * @description: 用于判断数量变化时優惠券的展示
     */
    realCouponList() {
      const obj = {};
      return this.couponsList.reduce((rs, item) => {
        if (
          (item.couponTemplate === 'NEWCOMER_EXPERIENCE' &&
            this.skillInfo.count !== 1) ||
          (item.couponTemplate.includes('EXCLUSIVE_COUPON') &&
            item.playerUuid !== this.skillInfo.userUuid) ||
          (item.couponTemplate.includes('TWITCH1') &&
            item.playerUuid !== this.skillInfo.userUuid) ||
          (item.couponTemplate.includes('TWITCH2') &&
            item.playerUuid !== this.skillInfo.userUuid)
        ) {
          return rs;
        }
        if (obj[item.uuid] === undefined) {
          obj[item.uuid] = rs.length;
          item.count = 1;
          rs.push(item);
        } else {
          rs[obj[item.uuid]].count += 1;
        }
        return rs;
      }, []);
    },
    // 是否藍新支付
    isLanxin() {
      const typeList = ['LanXinATM', 'LanXinCreditCard', 'LanXinSupermarket'];
      return typeList.includes(this.paymentMethod);
    },
    // 是否极速约单
    isQuickMatch() {
      return !!this.$route.query.quickMatchUuid;
    }
  },
  methods: {
    verifyEmail() {
      if (this.payType === 'Balance') return;
      if (!/^(\w+\.)*\w+@\w+(.\w+)+$/.test(this.email) && this.email) {
        this.$message.error('電子郵箱格式不正確');
        this.emailError = true;
      }
    },
    /**
     * @description 獲取買送最大送單數
     * @param Object { orderNum, giftAway }
     */
    getMaxSend(orderNum, giftAway) {
      /**
       * Number orderNum-- - 背包的总容量（ 在本需求中就是本订单中的总单数）
       * Number giftAway.length-- - 物品的种类个数(在本需求中就是满赠信息的数量)
       * Array weight-- - 物品的重量(在本需求中就是各个满赠的初始数量)
       * Array value-- - 物品的价值(在本需求中就是各个满赠的赠品数量）
       */
      if (!orderNum || !giftAway || !giftAway.length) return 0;
      const weight = giftAway.map(item => item.startNum);
      const value = giftAway.map(item => item.giftNum);
      const dp = new Array(giftAway.length + 1).fill(
        new Array(orderNum + 1).fill('')
      );
      //为了便于理解,将dp[i][0]和dp[0][j]均置为0，从1开始计算
      for (var i = 1; i < giftAway.length + 1; i++) {
        for (var j = 1; j < orderNum + 1; j++) {
          //如果第i件物品的重量大于背包容量j,则不装入背包
          //由于weight和value数组下标都是从0开始,故注意第i个物品的重量为weight[i-1],价值为value[i-1]
          if (weight[i - 1] > j) dp[i][j] = dp[i - 1][j];
          //这里是与0_1背包最大的区别，就是i不用减一，因为i的数量无限
          else
            dp[i][j] = Math.max(
              dp[i - 1][j],
              dp[i][j - weight[i - 1]] + value[i - 1]
            );
        }
      }
      //则容量为V的背包能够装入物品的最大值为
      var maxValue = dp[giftAway.length][orderNum];
      j = orderNum;
      var numStr = '';
      for (i = giftAway.length; i > 0; i--) {
        //若果dp[i][j]>dp[i-1][j],这说明第i件物品是放入背包的
        while (dp[i][j] > dp[i - 1][j]) {
          numStr = i + ' ' + numStr;
          j = j - weight[i - 1];
        }
        if (j == 0) break;
      }
      return maxValue || 0;
    },
    handleRadio(value) {
      this.tokenTerm = value;
    },
    /**
     * @description: 新增信用卡
     */
    creditCardInit() {
      this.creditVisible = true;
    },
    /**
     * @description: 获取订单基本信息
     */
    getSkillInfo() {
      return this.$http
        .get('/player/skill/detail/info', { id: this.$route.params.skill })
        .then(data => {
          if (data && data.msg === 'success') {
            this.skillInfo = data.data || {};
            // 如果有指定数量
            if (this.$route.params.count) {
              this.$set(this.skillInfo, 'count', this.$route.params.count | 0);
            }
            // 如果是极速约单
            if (this.quickMatchInfo.count | 0) {
              this.$set(this.skillInfo, 'count', this.quickMatchInfo.count | 0);
            }
            this.isFromNew = this.hasNewUserCoupons();
            // 如果符合新人体验,价格为新人体验价
            if (this.isFromNew) {
              this.skillInfo.count = 1;
            }
            this.$nextTick(() => {
              this.$refs.refUnit.getCurrentChange();
            });
            this.initCouponsList();
          }
        });
    },
    /**
     * @description: 获取账户余额信息
     */
    getUserAccount() {
      return this.$store.dispatch('app/getUserAccount').then(data => {
        if (data) {
          this.accountInfo = data || {};
        }
      });
    },
    getCoupons(couponsInfo) {
      this.currentCoupon = couponsInfo;
      this.coupons = couponsInfo.coupons;
      this.couponUuid = couponsInfo.uuid;
      this.couponType = couponsInfo.type;
      if (couponsInfo.type === 'NEWCOMER_EXPERIENCE') {
        this.isFromNew = true;
        this.skillInfo.count = 1;
        this.paymentMethod = 'Balance';
      } else {
        this.isFromNew = false;
        // this.paymentMethod = 'Balance';
      }
    },
    /**
     * @description: 获取用户優惠券
     */
    getCouponsList() {
      return this.$http
        .post('coupon/getUserCouponInfo', {
          couponStatusList: ['EFFECT'],
          userUuid: this.userInfo.uuid
        })
        .then(data => {
          this.couponsList = [];
          if (data && data.data && data.msg === 'success') {
            this.couponsList = data.data;
          }
        });
    },
    /**
     * @description: 处理優惠券list
     */
    initCouponsList() {
      this.couponsList = this.couponsList.filter(item => {
        // 愚人优惠券不展示
        if (item.couponTemplate === 'LIKE_FLOWER') return false;
        item.value = item.uuid;
        // 普通优惠券不做过滤
        const isOtherCoupon = ![
          'NEWCOMER_EXPERIENCE',
          /GIRL[1-3]_COUPON/,
          'NEW_EXCLUSIVE',
          'REGRESS_LOL_COUPON',
          'LOTTERY_LOL_COUPON'
        ].some(tpl => {
          if (Object.prototype.toString.call(tpl) === '[object RegExp]') {
            return tpl.test(item.couponTemplate);
          }
          return tpl === item.couponTemplate;
        });
        // 动物派对专用优惠券
        if (
          item.couponTemplate === 'GAME165' 
        ) {
          return 165 === this.skillInfo.gameId;
        }
        if (isOtherCoupon) return true;
        // 新人优惠券默认使用
        const isNewCoupon = item.couponTemplate === 'NEWCOMER_EXPERIENCE';
        if (isNewCoupon) {
          this.$nextTick(() => {
            this.$refs.couponsRef.useCoupons(item.uuid);
          });
        }
        // TODO: 临时判断虚拟恋人优惠券可用性
        const isGirl =
          /GIRL[1-3]_COUPON/.test(item.couponTemplate) &&
          this.skillInfo.gameId === 145;
        // 专属可用
        const isExclusive =
          (item.couponTemplate === 'NEW_EXCLUSIVE' &&
            item.playerUuid === this.playerUuid) ||
          (item.couponTemplate === 'LOTTERY_LOL_COUPON' &&
            1 === this.skillInfo.gameId);

        const backUserCoupon =
          item.couponTemplate === 'REGRESS_LOL_COUPON' &&
          this.skillInfo.gameId === 1 &&
          this.skillInfo.labelList &&
          this.skillInfo.labelList.some(item => item.labelId === 10); // 驗證英雄聯盟技能有回單王
        return isExclusive || isGirl || isNewCoupon || backUserCoupon;
      });
      // 如果從優惠券入口進入默認使用
      if (this.$route.query.couponUuid) {
        this.$nextTick(() => {
          this.$refs.couponsRef.useCoupons(this.$route.query.couponUuid);
        });
        return;
      }
      if (!this.isFromNew) {
        this.$nextTick(() => {
          this.$refs.couponsRef.useCoupons('');
        });
      }
      if (!this.isFromNew && !this.isQuickMatch) {
        this.$nextTick(() => {
          this.$refs.payTypeRef.selectThreeParty('balance');
        });
      }
    },
    /**
     * @description: 是否有新人優惠券
     */

    hasNewUserCoupons() {
      return this.couponsList.some(item => {
        return item.couponTemplate === 'NEWCOMER_EXPERIENCE';
      });
    },
    /**
     * @description: 获取支付类型的各项属性
     */
    getPayMethodInfo(methodInfo) {
      this.payMethodInfo = methodInfo;
    },
    /**
     * TODO:
     * @description 查询订单详情,未支付訂單進入,該功能暫時有流程阻礙，不做
     */
    getOrderDetail() {
      return this.$http
        .get('/order/detail', {
          orderNo: this.orderNo
        })
        .then(({ data }) => {
          let couponsInfo = data.couponEvent || {};
          this.orderInfo = data;
          this.paymentMethod = data.paymentMethod;
          this.couponUuid = couponsInfo.couponUuid;
          this.getPayMethodInfo(
            this.$refs.payTypeRef.filterItem(this.paymentMethod)
          );
          this.skillInfo = {
            avatarImageUrl: data.playerUserAvatar,
            count: data.orderItemVoList[0].count, // 數組各式為了未來多商品預留
            userUuid: data.playerUuid,
            nickname: data.playerUserNickname,
            salesPrice: data.orderItemVoList[0].salesPrice,
            salesUnit: data.orderItemVoList[0].salesUnit,
            gameName: data.orderItemVoList[0].gameName
          };
          // 如果有優惠券使用優惠券
          if (!this.couponUuid) return;

          this.couponsList = [
            {
              uuid: this.couponUuid,
              couponAmount: couponsInfo.deductionAmount
            }
          ];
          this.$nextTick(() => {
            this.$refs.couponsRef.useCoupons(this.couponUuid);
          });
        });
    },
    /**
     * @description: 極速約單
     */
    getGrabOrderCount(quickMatchUuid) {
      return this.$http
        .get('/match/quick/detail', { quickMatchUuid })
        .then(({ data }) => {
          if (!data) return;
          let count = data.count || 0; // 极速约单数量
          // 计算后的极速约单单价
          let salesPrice = 0;
          // 原价
          let originPrice = 0;
          let skill = data.grabItemDetailVo.find(item => {
            return (this.$route.params.skill | 0) === item.id;
          });
          salesPrice = skill.currentPrice;
          originPrice = skill.originPrice;
          // 如果是降价约单
          if (skill.reducePrice) {
            originPrice = skill.currentPrice;
          }
          this.quickMatchInfo = { salesPrice, count, originPrice };
        })
        .catch(() => {
          // 错误不影响正常下单
        });
    },
    init() {
      this.$store.dispatch('app/getUserAccount');
      this.submitAllow = false;
      let promiseList = [];
      if (this.$route.query.quickMatchUuid) {
        promiseList.push(
          this.getGrabOrderCount(this.$route.query.quickMatchUuid)
        );
      }
      if (this.orderNo) {
        promiseList.push(this.getOrderDetail(), this.getUserAccount());
      } else {
        promiseList.push(this.getUserAccount(), this.getCouponsList());
      }
      // 订单所需数据加载完成
      Promise.all(promiseList)
        .then(() => {
          return this.getSkillInfo();
        })
        .then(() => {
          this.submitAllow = true;
        });
    },
    pcSwitch() {
      if (window.innerWidth >= 600) {
        this.isPc = true;
      } else {
        this.isPc = false;
      }
    }
  },
  watch: {
    paymentMethod(newVal) {
      if (newVal === 'LanXinCreditCard') {
        this.creditCardInit();
      } else {
        this.creditVisible = false;
      }
    },
    userInfo: {
      handler: function(userInfo) {
        if (userInfo && userInfo.uuid) {
          const uuid = userInfo.uuid;
          this.$http
            .get('/payment/rechargeIsHold', { userUuid: uuid })
            .then(({ data }) => {
              if (data) {
                this.$confirm({
                  message:
                    '您當前賬號的信用異常，暫停下單/儲值功能。如有疑問，請搜索添加"nicee小管家"咨詢',
                  title: '提示',
                  showCancelButton: false,
                  showConfirmButton: true,
                  showClose: false,
                  confirmButtonText: '馬上聯係',
                  closeOnClickModal: false,
                  customClass: 'line-recharge-dialog-center'
                }).then(() => {
                  this.$router.push(`/player-detail/250226?skillId=121218`);
                });
              }
            })
            .catch(() => {});
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to.query', to.query);
    const { isTappay, status, stripe, fomo } = to.query;
    if (isTappay === 'true') {
      if (status !== '0') {
        history.go(-2);
      } else {
        next(vm => {
          vm.$nextTick(() => {
            const time = setInterval(() => {
              if (
                vm.$refs.submitButton &&
                vm.$refs.submitButton.userInfo.uuid &&
                vm.$refs.submitButton.skillInfo.userUuid
              ) {
                vm.$refs.submitButton.gotoChat();
                clearInterval(time);
              }
            }, 10);
          });
        });
      }
    } else if (stripe === 'true' || fomo === 'true') {
      next(vm => {
        vm.$nextTick(() => {
          const time = setInterval(() => {
            if (
              vm.$refs.submitButton &&
              vm.$refs.submitButton.userInfo.uuid &&
              vm.$refs.submitButton.skillInfo.userUuid
            ) {
              vm.$refs.submitButton.gotoChat();
              clearInterval(time);
              // history.go(-3);
            }
          }, 10);
        });
      });
    } else {
      next();
    }
  },
  created() {
    this.init();
    this.pcSwitch();
    window.addEventListener('resize', () => {
      this.pcSwitch();
    });
  }
};
</script>
<style lang="scss" scoped>
.credit-card {
  padding: 0 18px;
}
.order-submit-page {
  margin: 40px auto 180px !important;
  overflow-y: scroll;
  padding-bottom: 82px;
  background: #ffffff;
}
.order-head {
  padding: 18px;
  border-bottom: 2px solid #f4f4f4;
  font-size: 22px;
}
.white-block {
  background: #ffffff;
  border-bottom: solid 10px #f9f9f9;
}
.submit-order {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 100;
}
.email-info {
  display: flex;
}
.email-title {
  margin-right: 28px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 500;
}
.tip-wrap {
  margin-top: 6px;
  font-size: 14px;
  line-height: 22px;
  color: #8c94aa;
}
.eamil-Error {
  /deep/ .el-input__inner {
    border: 1px solid #f56c6c;
  }
}
.rebate-tip {
  bottom: -76px;
}
.rebate-per {
  font-weight: 700;
  font-size: 18px;
  color: #ffe87b;
}
@media screen and (min-width: 600px) {
  .order-submit-page {
    width: 1200px;
    padding: 30px 40px 0;
    overflow: hidden;
    margin: 40px auto 100px;
  }
  .order-head {
    width: 744px;
    padding: 0 0 30px;
  }
  .pc-container-left {
    float: left;
    width: 744px;
  }
  .pc-container-right {
    position: relative;
    float: right;
    width: 246px;
    padding: 15px 15px 20px;
    // margin: 46px 0 0 0;
    background: #f6f6f6;
    border-radius: 4px;
  }
  .rebate-tip {
    position: absolute;
    display: flex;
    top: -46px;
    left: 0;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 34px;
    background: #ea722f;
    border-radius: 4px;
    font-size: 13px;
    color: #ffffff;
  }
  .submit-order {
    position: relative;
    bottom: 0;
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .credit-wrap {
    padding: 0 0 0 98px;
  }
}
</style>
